import {
  DialogForm,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
  Input,
  LineColorPicker,
} from '@ais-ui/ui-core';
import React from 'react';
import { GroupMultiSelect } from '../../../Groups/GroupMultiSelect';
import { useLocalization } from '@ais-ui/locale-management';
import { useSaveShiplist } from './useSaveShiplist';
import { ShiplistConfirmationDialog } from './ShiplistConfirmationDialog';
import { useMutateShiplistContext } from './MutateShiplistContext';
import { AddShipsToListFormField } from './AddShipsToListFormField';

const SaveShiplistForm = () => {
  const { messages } = useLocalization();
  const { shiplist, form } = useMutateShiplistContext();

  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <div className="flex justify-between">
              <FormLabel>{messages.shiplistsSaveShiplistNameLabel} *</FormLabel>
              <InfoIconTooltip>{messages.shiplistsSaveNameOfShiplistTooltip}</InfoIconTooltip>
            </div>
            <FormControl onChange={() => form.clearErrors()}>
              <Input
                disabled={shiplist !== undefined}
                id="shiplist-name"
                type="text"
                placeholder={messages.shiplistsSaveShiplistNamePlaceholder}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        key="color"
        control={form.control}
        name="color"
        render={({ field }) => (
          <FormItem>
            <div className="flex justify-between">
              <FormLabel>{messages.shiplistsSaveColorLabel} *</FormLabel>
              <InfoIconTooltip>{messages.shiplistsSaveColorPlaceholder}</InfoIconTooltip>
            </div>
            <FormControl onChange={() => form.clearErrors()}>
              <LineColorPicker
                background={field.value}
                setBackground={(color) => {
                  form.setValue('color', color);
                }}
                className="flex-shrink-0 flex-grow-0 w-12 p-0"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        key="selectedGroups"
        control={form.control}
        name="selectedGroups"
        render={({ field }) => (
          <FormItem>
            <div className="flex justify-between">
              <FormLabel>{messages.shiplistsSaveShareLabel}</FormLabel>
              <InfoIconTooltip>{messages.shiplistsSaveShareTooltip}</InfoIconTooltip>
            </div>
            <FormControl onChange={() => form.clearErrors()}>
              <GroupMultiSelect {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <AddShipsToListFormField></AddShipsToListFormField>
    </>
  );
};

export function SaveShiplistDialog() {
  const { messages } = useLocalization();

  const { showDialog, setShowDialog, action, isLoading, isSubmitting, form } =
    useMutateShiplistContext();

  const {
    onSubmit,
    handleCancel,
    handleConfirm,
    showConfirmDialog,
    setShowConfirmDialog,
  } = useSaveShiplist();
  const [dialogTitle, dialogDescription] =
    action === 'edit'
      ? [messages.shiplistsSaveEditTitle, messages.shiplistsSaveEditSubtitle]
      : [
          messages.shiplistsSaveCreateTitle,
          messages.shiplistsSaveCreateSubtitle,
        ];

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={setShowDialog}
        title={dialogTitle}
        description={dialogDescription}
        isLoading={isLoading}
        hasLoaded={!isLoading}
        buttonId="shiplist-submit-button"
        buttonText={
          isSubmitting ? messages.genericSubmitting : messages.genericSubmit
        }
        buttonDisabled={isSubmitting}
        buttonOnClick={form.handleSubmit(onSubmit)}
        observeResize={false}
        className="flex-col-reverse"
      >
        <SaveShiplistForm />
      </DialogForm>
      <ShiplistConfirmationDialog
        open={showConfirmDialog}
        onOpenChange={setShowConfirmDialog}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </Form>
  );
}
